import { env } from './enviroment';
export interface XhrQueryParam {
  name: string;
  value?: string | boolean | number;
}

export const getQueryParamsExpression = (params?: XhrQueryParam[]): string => {
  if (!params) return '';

  let query = '';
  let separator = '?';
  params.forEach((param) => {
    if (
      param.name.length > 0 &&
      ((typeof param.value == 'string' && param.value.length > 0) ||
        typeof param.value == 'boolean' ||
        typeof param.value == 'number')
    ) {
      if (typeof param.value == 'boolean') param.value = param.value ? '1' : '0';
      query = `${query}${separator}${param.name}=${param.value}`;
      separator = '&';
    }
  });
  return query;
};

class PathManagement {
  private searchUrl: string;
  private cartUrl: string;
  private detailUrl: string;
  private baseurlQuery: string;
  private loginUrl: string;
  private loginByActivationUrl: string;
  private logoutUrl: string;
  private loginRRSSUrl: string;
  private checkLoginUrl: string;
  private checkoutUrl: string;
  private pedidoUrl: string;
  private newUserUrl: string;
  private districts: string;
  private city: string;
  private VincularRRSS: string;
  private recomendedProducts: string;
  private topCarousel: string;
  private staticBanners: string;
  private countdown: string;
  private staffPicks: string;
  private featuredCards: string;
  private popularBrands: string;
  private bannerInterior: string;
  private wishlist: string;
  private userInfo: string;
  private contact: string;
  private address: string;
  private user: string;
  private orders: string;
  private frequent: string;
  private orderWishlist: string;
  private planetPlus: string;
  private planetPlusCtaCte: string;
  private isPlanetPlusSocio: string;
  private getPPDataForClient: string;
  private dataForDropdown: string;
  private suppliesTypes: string;
  private suppliesModels: string;
  private suppliesProducts: string;
  private suppliesProductsForInsumo: string;
  private suppliesModelsAutoComplete: string;
  private suppliesInsumosAutoComplete: string;
  private suppliesProduct: string;
  private suppliesAgregarImpresora: string;
  private suppliesMisImpresoras: string;
  private insumoNoEncontrado: string;
  private saveOpinionUrl: string;
  private costoEnvioByCpId: string;
  private ppDetail: string;
  private notifications: string;
  private allNotifications: string;
  private allNotificationsList: string;
  private read1Notification: string;
  private readNotifications: string;
  private readAllNotifications: string;
  private estadoSeguimientoPedido: string;
  private alternativeIdentity: string;
  private backIdentity: string;
  private itemStock: string;
  private newsletter: string;
  private coupon: string;
  private activationCode: string;
  private getDomicilios: string;
  private getContactos: string;
  private offers: string;
  private novedades: string;
  private direccionFacturacion: string;
  private direccionEntrega: string;
  private transportistasForDropdown: string;
  private encuestaPP: string;
  private encuestaCliente: string;

  constructor() {
    this.cartUrl = env.apiBaseUrl + '/action/Carrito';
    this.searchUrl = env.apiBaseUrl + '/action/searchKey';
    this.detailUrl = env.apiBaseUrl + '/action/Articulo/';
    this.baseurlQuery = env.apiBaseUrl + '/action/Catalogo?';
    this.offers = env.apiBaseUrl + '/action/Ofertas?';
    this.novedades = env.apiBaseUrl + '/action/Novedades?';
    this.loginUrl = env.apiBaseUrl + '/action/login';
    this.loginByActivationUrl = env.apiBaseUrl + '/action/loginByActivationUrl';
    this.logoutUrl = env.apiBaseUrl + '/action/logout';
    this.loginRRSSUrl = env.apiBaseUrl + '/action/loginRRSS';
    this.checkLoginUrl = env.apiBaseUrl + '/action/isLoggedIn';
    this.checkoutUrl = env.apiBaseUrl + '/action/Checkout';
    this.pedidoUrl = env.apiBaseUrl + '/action/Pedido';
    this.newUserUrl = env.apiBaseUrl + '/action/Checkout';
    this.districts = env.apiBaseUrl + '/action/Location?dispatcher=Localidad&codProvincia';
    this.city = env.apiBaseUrl + '/action/Location?dispatcher=Provincia';
    this.VincularRRSS = env.apiBaseUrl + '/action/Usuario?dispatcher=VincularRRSS';
    this.recomendedProducts = env.apiBaseUrl + '/action/recommendations?artId=';
    this.topCarousel = env.apiBaseUrl + '/action/Banners?dispatcher=bannersPrincipales';
    this.staticBanners = env.apiBaseUrl + '/action/Banners?dispatcher=bannersSecundarios';
    this.countdown = env.apiBaseUrl + '/action/Banners?dispatcher=bannersFullScreen';
    this.staffPicks = env.apiBaseUrl + '/action/Banners?dispatcher=bannersSeleccionPersonal';
    this.featuredCards = env.apiBaseUrl + '/action/Banners?dispatcher=bannersArticulosDestacados';
    this.popularBrands = env.apiBaseUrl + '/action/Banners?dispatcher=bannersMarcasPopulares';
    this.bannerInterior = env.apiBaseUrl + '/action/Banners?dispatcher=bannersInterior&';
    this.wishlist = env.apiBaseUrl + '/action/Favoritos';
    this.userInfo = env.apiBaseUrl + '/action/UserInfo';
    this.contact = env.apiBaseUrl + '/action/Contacto/';
    this.address = env.apiBaseUrl + '/action/Domicilio/';
    this.user = env.apiBaseUrl + '/action/Usuario';
    this.orders = env.apiBaseUrl + '/action/Pedido';
    this.frequent = env.apiBaseUrl + '/action/Frecuentes';
    this.orderWishlist = env.apiBaseUrl + '/action/Pedido?id=';
    this.planetPlus = env.apiBaseUrl + '/action/PlanetPlus';
    this.planetPlusCtaCte = env.apiBaseUrl + '/action/PlanetPlusCtaCte';
    this.isPlanetPlusSocio = env.apiBaseUrl + '/action/PlanetPlus?dispatcher=isSocioPlanetPlus&cliId=';
    this.getPPDataForClient = env.apiBaseUrl + '/action/PlanetPlus?dispatcher=getPlanetPlusDataForClient&cliId=';
    this.dataForDropdown = env.apiBaseUrl + '/action/Equipo?dispatcher=getEquipoDataForDropdown';
    this.suppliesTypes = env.apiBaseUrl + '/action/BuscadorInsumos?dispatcher=getTipos&eqm_id=';
    this.suppliesModels = env.apiBaseUrl + '/action/BuscadorInsumos?dispatcher=getModelos&eqm_id=';
    this.suppliesProducts =
      env.apiBaseUrl + '/action/BuscadorInsumos?dispatcher=getProductsForDevice&emo_id=';
    this.suppliesProductsForInsumo =
      env.apiBaseUrl + '/action/BuscadorInsumos?dispatcher=getProductForInsumo&art_id=';
    this.suppliesModelsAutoComplete =
      env.apiBaseUrl + '/action/BuscadorInsumos?dispatcher=getAutocompleteDataForEquipoModelo&term=';
    this.suppliesInsumosAutoComplete =
      env.apiBaseUrl + '/action/BuscadorInsumos?dispatcher=getAutocompleteDataForEquipoInsumo&term=';
    this.suppliesProduct = this.detailUrl;
    this.suppliesAgregarImpresora = env.apiBaseUrl + '/action/BuscadorInsumos?dispatcher=agregarImpresora';
    this.suppliesMisImpresoras = env.apiBaseUrl + '/action/BuscadorInsumos?dispatcher=getMisImpresoras';
    this.insumoNoEncontrado = env.apiBaseUrl + '/action/BuscadorInsumos?dispatcher=saveInsumoNoEncontrado';
    this.saveOpinionUrl = env.apiBaseUrl + '/action/ArticuloValoracionOpinion';
    this.costoEnvioByCpId = env.apiBaseUrl + '/action/CostoEnvio?dispatcher=getCostoEnvioFromCp&cp_id=';
    this.ppDetail =
      env.apiBaseUrl + '/action/PlanetPlusCtaCte?dispatcher=getOperacionDebitoByPpccoId&ppcco_id=';
    this.notifications = env.apiBaseUrl + '/action/BandejaMsg?dispatcher=list';
    this.allNotifications = env.apiBaseUrl + '/action/BandejaMsg?dispatcher=listAll';
    this.allNotificationsList = env.apiBaseUrl + '/action/BandejaMsg?dispatcher=listAllNotifications';
    this.read1Notification = env.apiBaseUrl + '/action/BandejaMsg?dispatcher=setMsgLeido&bms_id=';
    this.readNotifications = env.apiBaseUrl + '/action/BandejaMsg';
    this.readAllNotifications = env.apiBaseUrl + '/action/BandejaMsg?dispatcher=setAllMsgLeidos';
    this.estadoSeguimientoPedido = env.apiBaseUrl + '/action/Pedido?dispatcher=getEstadoPedidoById&ped_id=';
    this.alternativeIdentity = env.apiBaseUrl + '/action/Usuario?dispatcher=setAlternativeIdentity&email=';
    this.backIdentity = env.apiBaseUrl + '/action/Usuario?dispatcher=getBackIdentity';
    this.itemStock = env.apiBaseUrl + '/action/Articulo/id/';
    this.newsletter = env.apiBaseUrl + '/action/Newsletter?dispatcher=toggleNewsletter';
    this.coupon = env.apiBaseUrl + '/action/Carrito?dispatcher=aplicaCupon';
    this.activationCode = env.apiBaseUrl + '/action/Usuario?dispatcher=resendCodigoActivacion';
    this.getDomicilios = env.apiBaseUrl + '/action/Domicilio?dispatcher=getDomicilios';
    this.getContactos = env.apiBaseUrl + '/action/Contacto?dispatcher=getContactos';
    this.direccionFacturacion = env.apiBaseUrl + '/action/Domicilio?dispatcher=getDomicilioFacturacion';
    this.direccionEntrega = env.apiBaseUrl + '/action/Domicilio?dispatcher=getDomiciliosEntrega';
    this.transportistasForDropdown =
      env.apiBaseUrl + '/action/Domicilio?dispatcher=getTrasportistasForDropdown';
    this.encuestaPP = env.apiBaseUrl + '/action/Encuesta?dispatcher=getPlanetPlusEncuesta'
    this.encuestaCliente = env.apiBaseUrl + '/action/Encuesta?dispatcher=checkEncuestaCliente&cliId=';
  }

  getUrlForAction(action: string, params?: XhrQueryParam[]) {
    return `${env.apiBaseUrl}/action/${action}${getQueryParamsExpression(params)}`;
  }

  getUrlForEntityAction(entity: string, action: string, params?: XhrQueryParam[]) {
    const actionParam = { name: 'dispatcher', value: action };
    return this.getUrlForAction(entity, params ? [...params, actionParam] : [actionParam]);
  }

  //Se fija que página del catalogo está activa
  // getActivePage() {
  //   let activePage = 1;

  //   if (
  //     document.getElementsByClassName('pagination').length > 0 &&
  //     document.getElementsByClassName('pagination')[0].children[0].children[0].children.length > 0
  //   ) {
  //     // @ts-expect-error snas
  //     for (let val of document.getElementsByClassName('pagination')[0].children[0].children[0].children) {
  //       if (val.classList.contains('active')) {
  //         return (activePage = val.innerText);
  //       }
  //     }
  //   }
  //   console.log(activePage)

  //   return activePage;
  // }

  getCartUrl() {
    return this.cartUrl;
  }

  getSearchKeyUrl() {
    return this.searchUrl;
  }

  getLoginUrl() {
    return this.loginUrl;
  }

  getLoginByActivationUrl() {
    return this.loginByActivationUrl;
  }

  getLogoutUrl() {
    return this.logoutUrl;
  }

  getLoginRRSSUrl() {
    return this.loginRRSSUrl;
  }

  getLoginCheckUrl() {
    return this.checkLoginUrl;
  }

  getImgURL() {
    return env.imagesBaseUrl;
  }

  getCheckoutUrl() {
    return this.checkoutUrl;
  }

  getNewUserUrl() {
    return this.newUserUrl;
  }

  getDistricts(params: string) {
    let url = this.districts + '=' + params;
    return url;
  }

  getCityUrl() {
    return this.city;
  }

  getPedidoUrl() {
    return this.pedidoUrl;
  }

  //arma url para api de catalogo
  getCatalogueURL(
    accessType: string,
    accessValue: string,
    page: number,
    filters: string,
    orden: string,
    accessType2: string,
    accessValue2: string
  ) {

    let accessValueForUrl = accessValue;
    if (accessValue) {
      accessValueForUrl = accessValue.replaceAll('-', '_');
    }


    const secondAccess = () => {
      if (accessType2 && accessValue2) {
        return 'accessType=' + accessType2 + '&accessValue=' + accessValue2 + '&';
      }
      return ""
    };

    let activePage = null;

    if (page) {
      activePage = page + 1;
    } else {
      activePage = 1;
    }

    let url = this.baseurlQuery;


    url = url + 'accessType=' + accessType + '&accessValue=' + accessValueForUrl + "&"+ secondAccess();

    url = url + 'resultsPerPage=12&page=' + activePage + '&' + 'orderBy=' + orden + '&';

    if (filters && filters[0] && filters[0][1]) {
      for (let i = 0; i < filters.length; i++) {
        url =
          url +
          '&filters[' +
          i +
          '][type]=' +
          filters[i][0] +
          '&filters[' +
          i +
          '][value]=' +
          filters[i][1].replace(/ /g, '%20');
      }



      url = encodeURI(url);

      return url;
    }
    return url;
  }

  getOffersURL(accessType: string, accessValue: string, page: number, filters: string, orden: string) {
    let activePage = null;

    if (page) {
      activePage = page + 1;
    } else {
      activePage = 1;
    }

    let url = this.offers;
    url = url + 'accessType=' + accessType + '&accessValue=' + accessValue + '&';

    url = url + 'resultsPerPage=12&page=' + activePage + '&' + 'orderBy=' + orden + '&';

    if (filters) {
      for (let i = 0; i < filters.length; i++) {
        url =
          url +
          '&filters[' +
          i +
          '][type]=' +
          filters[i][0] +
          '&filters[' +
          i +
          '][value]=' +
          filters[i][1].replace(/ /g, '%20');
      }

      return url;
    }
    return url;
  }

  getNovedadesURL(accessType: string, accessValue: string, page: number, filters: string, orden: string) {
    let activePage = null;

    if (page) {
      activePage = page + 1;
    } else {
      activePage = 1;
    }

    let url = this.novedades;
    url = url + 'accessType=' + accessType + '&accessValue=' + accessValue + '&';

    url = url + 'resultsPerPage=12&page=' + activePage + '&' + 'orderBy=' + orden + '&';

    if (filters) {
      for (let i = 0; i < filters.length; i++) {
        url =
          url +
          '&filters[' +
          i +
          '][type]=' +
          filters[i][0] +
          '&filters[' +
          i +
          '][value]=' +
          filters[i][1].replace(/ /g, '%20');
      }

      return url;
    }
    return url;
  }

  //arma url para api de detalle de producto
  getDetailURL(id: string) {
    let url = this.detailUrl;

    url = url + id;
    return url;
  }

  getRecomendedProducts(id: string) {
    let url = this.recomendedProducts;
    url = url + id;
    return url;
  }

  getVincularRRSSUrl() {
    return this.VincularRRSS;
  }

  getTopCarousel() {
    return this.topCarousel;
  }

  getStaticBannersUrl() {
    return this.staticBanners;
  }

  getCountdownUrl() {
    return this.countdown;
  }

  getStaffPicksUrl() {
    return this.staffPicks;
  }

  getFeaturedCardsUrl() {
    return this.featuredCards;
  }

  getPopularBrandsUrl() {
    return this.popularBrands;
  }

  getBannerInteriorUrl(type) {
    let url = this.bannerInterior + type;
    return url;
  }

  getWishlistUrl() {
    return this.wishlist;
  }

  getUserInfo() {
    return this.userInfo;
  }

  getContact(id) {
    let url = this.contact + id;
    return url;
  }

  getAddress(id) {
    let url = this.address + id;
    return url;
  }

  getUser() {
    return this.user;
  }

  getOrders() {
    return this.orders;
  }

  getFrequent() {
    return this.frequent;
  }

  getOrderToWishlist(id) {
    let url = this.orderWishlist + id + '&dispatcher=favoritos';
    return url;
  }

  getOrderDetail(id) {
    let url = this.orderWishlist + id + '&dispatcher=items';
    return url;
  }

  getPlanetPlus() {
    return this.planetPlus;
  }

  getPlanetPlusCtaCte() {
    return this.planetPlusCtaCte;
  }

  getIsPlanetPlusSocio(cliId) {
    return this.isPlanetPlusSocio + cliId;
  }

  getPPData(cliId) {
    return this.getPPDataForClient + cliId;
  }

  getDataForDropdown() {
    return this.dataForDropdown;
  }

  getSuppliesTypes(id) {
    let url = this.suppliesTypes + id;
    return url;
  }

  getSuppliesModels(brandId, typeId) {
    let url = this.suppliesModels + brandId + '&eqt_id=' + typeId;
    return url;
  }

  getSuppliesProducts(id) {
    let url = this.suppliesProducts + id;
    return url;
  }

  getSuppliesProductsForInsumo(id, artt_id) {
    let url = this.suppliesProductsForInsumo + id + '&artt_id=' + artt_id;
    return url;
  }

  getSuppliesProduct(art_id) {
    let url = this.suppliesProduct + art_id;
    return url;
  }

  getSuppliesModelsAutoComplete(term) {
    let url = this.suppliesModelsAutoComplete + term;
    return url;
  }

  getSuppliesInsumosAutoComplete(term) {
    let url = this.suppliesInsumosAutoComplete + term;
    return url;
  }

  agregarImpresora(emo_id, nombre, sector) {
    let url = `${this.suppliesAgregarImpresora}&emo_id=${emo_id}&nombre=${nombre}&sector=${sector}`;
    return url;
  }

  getMisImpresoras() {
    let url = this.suppliesMisImpresoras;
    return url;
  }

  saveInsumoNoEncontrado() {
    let url = this.insumoNoEncontrado;
    return url;
  }

  saveOpinion() {
    let url = this.saveOpinionUrl;
    return url;
  }

  getCostoEnvioByCpId(cp_id) {
    let url = this.costoEnvioByCpId + cp_id;
    return url;
  }

  getPPDetail(pp_id) {
    let url = this.ppDetail + pp_id;
    return url;
  }

  getNotifications() {
    return this.notifications;
  }

  getAllNotifications() {
    return this.allNotifications;
  }

  getAllNotificationsList() {
    return this.allNotificationsList;
  }

  getReadNotificationsUrl() {
    let url = this.readNotifications;
    return url;
  }

  getRead1Notification(id) {
    let url = this.read1Notification + id;
    return url;
  }

  getReadAllNotifications() {
    return this.readAllNotifications;
  }

  getEstadoPedidoById(ped_id) {
    let url = this.estadoSeguimientoPedido + ped_id;
    return url;
  }

  getAlternativeIdentity(email) {
    let url = this.alternativeIdentity + email;
    return url;
  }

  getBackIdentity() {
    let url = this.backIdentity;
    return url;
  }

  encodeURL(url: string) {
    return encodeURIComponent(url);
  }

  getItemStock(itemID) {
    let url = this.itemStock + itemID + '/addValue/avail';
    return url;
  }

  getNewsletterUrl() {
    return this.newsletter;
  }

  getCouponUrl() {
    let url = this.coupon;
    return url;
  }

  getActivationCodeUrl() {
    let url = this.activationCode;
    return url;
  }

  getDomiciliosForList() {
    let url = this.getDomicilios;
    return url;
  }

  getContactosForList() {
    let url = this.getContactos;
    return url;
  }

  getDireccionFacturacion() {
    return this.direccionFacturacion;
  }

  getDireccionEntrega() {
    return this.direccionEntrega;
  }

  getTransportistasForDropdown() {
    return this.transportistasForDropdown;
  }

  getEncuestaPPUrl() {
    return this.encuestaPP;
  }

  getEncuestaClienteUrl(cliId) {
    return this.encuestaCliente + cliId;
  }
}

export default PathManagement;
